// // Frontend VehicleGatePass.js (updated with download)
// import * as React from "react";
// import {
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   Card,
//   TextField,
//   Button,
//   Grid,
//   IconButton,
//   Stack,
//   Tooltip,
//   Typography,
//   Chip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Box,
//   CircularProgress,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   CheckCircle as AcceptIcon,
//   Cancel as RejectIcon,
//   Pending as PendingIcon,
//   DirectionsCar as CarIcon,
//   Email as EmailIcon,
//   Download as DownloadIcon,
// } from "@mui/icons-material";
// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import swal from "sweetalert";
// import { gridSpacing } from "store/constant";
// import MainCard from "ui-component/cards/MainCard";
// import { useDebounce } from "hooks/useDebounced";

// export default function VehicleGatePass() {
//   const navigate = useNavigate();
//   const [page, setPage] = useState(0);
//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [rows, setRows] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [sendingPass, setSendingPass] = useState(false);
//   const [updatingStatus, setUpdatingStatus] = useState({});
//   const [downloading, setDownloading] = useState({});

//   const debouncedSearch = useDebounce(search, 1000);

//   // Fetch vehicle gate pass list
//   const fetchVehicleGatePasses = async () => {
//     setLoading(true);
//     try {
//       const queryParams = new URLSearchParams({
//         page: page + 1,
//         limit: rowsPerPage,
//         search,
//         status: statusFilter,
//       });

//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/vehicle-gate-pass-list?${queryParams}`,
//         {
//           method: "GET",
//           headers: {
//             authkey: process.env.REACT_APP_AUTH_KEY,
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const result = await response.json();

//       if (result.code === 200) {
//         setRows(result.data.vehiclePasses || []);
//         setTotal(result.data.pagination?.total || 0);
//       } else {
//         toast.error(result.message || "Failed to fetch vehicle gate passes");
//         setRows([]);
//         setTotal(0);
//       }
//     } catch (error) {
//       console.error("Error fetching vehicle gate passes:", error);
//       toast.error("Something went wrong while fetching vehicle gate passes");
//       setRows([]);
//       setTotal(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchVehicleGatePasses();
//   }, [page, rowsPerPage, debouncedSearch, statusFilter]);

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   const handleStatusFilter = (event) => {
//     setStatusFilter(event.target.value);
//     setPage(0);
//   };

//   // Update vehicle gate pass status
//   const updateVehicleStatus = async (id, newStatus, name) => {
//     if (updatingStatus[id]) return;

//     const actionText = newStatus === "accept" ? "Accept" : "Reject";

//     swal({
//       title: `${actionText} ${name}?`,
//       text: `Are you sure you want to ${actionText.toLowerCase()} this vehicle gate pass?`,
//       icon: newStatus === "accept" ? "success" : "error",
//       buttons: ["Cancel", actionText],
//       dangerMode: newStatus === "reject",
//     }).then(async (willProceed) => {
//       if (!willProceed) return;

//       try {
//         setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}/update-vehicle-gate-pass-status/${id}`,
//           {
//             method: "PUT",
//             headers: {
//               authkey: process.env.REACT_APP_AUTH_KEY,
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ status: newStatus }),
//           }
//         );

//         const result = await response.json();

//         if (result.code === 200) {
//           toast.success(`Vehicle Gate Pass ${actionText}ed successfully`);
//           setRows((prev) =>
//             prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item))
//           );
//         } else {
//           toast.error(result.message || `Failed to ${actionText.toLowerCase()} gate pass`);
//         }
//       } catch (error) {
//         console.error("Error updating gate pass status:", error);
//         toast.error("Something went wrong while updating gate pass status");
//       } finally {
//         setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
//       }
//     });
//   };

//   // Send gate pass
//   const sendGatePass = async (id, name) => {
//     setSendingPass(true);
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/send-vehicle-gate-pass/${id}`,
//         {
//           method: "POST",
//           headers: {
//             authkey: process.env.REACT_APP_AUTH_KEY,
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const result = await response.json();

//       if (result.code === 200) {
//         toast.success(`Vehicle gate pass sent successfully to ${name}`);
//       } else {
//         toast.error(result.message || "Failed to send gate pass");
//       }
//     } catch (error) {
//       console.error("Error sending gate pass:", error);
//       toast.error("Something went wrong while sending vehicle gate pass");
//     } finally {
//       setSendingPass(false);
//     }
//   };

//   const handleDownload = async (id, visitorId) => {
//     if (downloading[id]) return;

//     setDownloading((prev) => ({ ...prev, [id]: true }));

//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/download-gatepass-vehicle/${id}`,
//         {
//           method: "GET",
//           headers: {
//             authkey: process.env.REACT_APP_AUTH_KEY,
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Download failed:", errorText);
//         toast.error("Failed to download gate pass");
//         return;
//       }

//       // ✅ Check if response has content
//       const contentType = response.headers.get("content-type");
//       if (!contentType || !contentType.includes("application/pdf")) {
//         console.error("Invalid content type:", contentType);
//         toast.error("Invalid PDF response");
//         return;
//       }

//       const blob = await response.blob();

//       // ✅ Verify blob has content
//       if (blob.size === 0) {
//         console.error("Empty PDF received");
//         toast.error("Empty PDF file");
//         return;
//       }

//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `GatePass_${visitorId}.pdf`;
//       document.body.appendChild(a);
//       a.click();

//       // ✅ Cleanup after a short delay
//       setTimeout(() => {
//         window.URL.revokeObjectURL(url);
//         document.body.removeChild(a);
//         toast.success("Gate pass downloaded successfully");
//       }, 100);
//     } catch (error) {
//       console.error("Error downloading gate pass:", error);
//       toast.error("Something went wrong while downloading gate pass");
//     } finally {
//       setDownloading((prev) => ({ ...prev, [id]: false }));
//     }
//   };

//   // Delete vehicle gate pass
//   const deleteVehicleGatePass = (id, name) => {
//     swal({
//       title: `Delete ${name}?`,
//       text: "This will permanently delete this vehicle gate pass record!",
//       icon: "warning",
//       buttons: ["Cancel", "Delete"],
//       dangerMode: true,
//     }).then(async (willDelete) => {
//       if (!willDelete) return;

//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}/delete-vehicle-gate-pass/${id}`,
//           {
//             method: "DELETE",
//             headers: {
//               authkey: process.env.REACT_APP_AUTH_KEY,
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         const result = await response.json();

//         if (result.code === 200) {
//           toast.success("Vehicle gate pass deleted successfully");
//           setRows((prev) => prev.filter((item) => item._id !== id));
//           setTotal((prev) => prev - 1);
//         } else {
//           toast.error(result.message || "Failed to delete vehicle gate pass");
//         }
//       } catch (error) {
//         console.error("Error deleting vehicle gate pass:", error);
//         toast.error("Something went wrong while deleting vehicle gate pass");
//       }
//     });
//   };

//   const getStatusChip = (status) => {
//     const statusConfig = {
//       pending: { color: "warning", icon: <PendingIcon />, label: "Pending" },
//       accept: { color: "success", icon: <AcceptIcon />, label: "Accepted" },
//       reject: { color: "error", icon: <RejectIcon />, label: "Rejected" },
//     };
//     const config = statusConfig[status] || statusConfig.pending;

//     return (
//       <Chip
//         icon={config.icon}
//         label={config.label}
//         color={config.color}
//         size="small"
//         variant="outlined"
//       />
//     );
//   };

//   const formatDate = (dateString) =>
//     new Date(dateString).toLocaleDateString("en-IN", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });

//   return (
//     <>
//       <Grid container spacing={2} sx={{ mb: 2 }}>
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Search vehicle gate passes..."
//             type="search"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Name, vehicle no, company..."
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <FormControl fullWidth>
//             <InputLabel>Status Filter</InputLabel>
//             <Select value={statusFilter} onChange={handleStatusFilter} label="Status Filter">
//               <MenuItem value="all">All Status</MenuItem>
//               <MenuItem value="pending">Pending</MenuItem>
//               <MenuItem value="accept">Accepted</MenuItem>
//               <MenuItem value="reject">Rejected</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>

//       <MainCard
//         title={
//           <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
//             <Grid item>
//               <Typography variant="h3">Temporary Vehicle Gate Pass ({total} total)</Typography>
//             </Grid>
//             <Grid item>
//               {/* <Button
//                 variant="contained"
//                 onClick={() => navigate("/add-vehicle-gate-pass")}
//                 startIcon={<AddIcon />}
//               >
//                 Add Vehicle Gate Pass
//               </Button> */}
//             </Grid>
//           </Grid>
//         }
//         content={false}
//       >
//         <Card>
//           <Paper sx={{ width: "100%", overflow: "hidden" }}>
//             <TableContainer sx={{ maxHeight: 600 }}>
//               <Table stickyHeader aria-label="vehicle gate pass table">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>S. No.</TableCell>
//                     <TableCell>ID/Iqama</TableCell>
//                     <TableCell>Name</TableCell>
//                     <TableCell>Vehicle No</TableCell>
//                     <TableCell>Company</TableCell>
//                     <TableCell>Contact</TableCell>
//                     <TableCell>Entry Time</TableCell>
//                     <TableCell>HOD Status</TableCell>
//                     <TableCell>Status</TableCell>
//                     <TableCell align="center">Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {loading ? (
//                     <TableRow>
//                       <TableCell colSpan={10} align="center">
//                         <Typography>Loading...</Typography>
//                       </TableCell>
//                     </TableRow>
//                   ) : rows.length === 0 ? (
//                     <TableRow>
//                       <TableCell colSpan={10} align="center">
//                         <Typography>No vehicle gate passes found</Typography>
//                       </TableCell>
//                     </TableRow>
//                   ) : (
//                     rows.map((row, index) => (
//                       <TableRow hover key={row._id}>
//                         <TableCell>{page * rowsPerPage + index + 1}</TableCell>
//                         <TableCell>
//                           <Typography variant="body2" fontWeight="bold" color="primary">
//                             {row.idIqama}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="body2" fontWeight="bold">
//                             {row.fullName}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Chip
//                             icon={<CarIcon />}
//                             label={row.vehiclePlateNo || "N/A"}
//                             size="small"
//                             variant="outlined"
//                             color="primary"
//                           />
//                         </TableCell>
//                         <TableCell>{row.companyName}</TableCell>
//                         <TableCell>
//                           <Typography variant="body2">{row.mobile}</Typography>
//                           <Typography variant="caption" color="textSecondary">
//                             {row.email}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="caption" display="block">
//                             From: {formatDate(row.visitStart)}
//                           </Typography>
//                           <Typography variant="caption" color="textSecondary">
//                             To: {formatDate(row.visitEnd)}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>{getStatusChip(row.staff_status)}</TableCell>
//                         <TableCell>{getStatusChip(row.status)}</TableCell>
//                         <TableCell align="center">
//                           <Stack direction="row" spacing={0.5} justifyContent="center">
//                             <Tooltip title="View Details">
//                               <IconButton
//                                 size="small"
//                                 color="info"
//                                 onClick={() => navigate(`/vehicle-gatepass/${row._id}`)}
//                               >
//                                 <ViewIcon fontSize="small" />
//                               </IconButton>
//                             </Tooltip>

//                             {row.status === "pending" && (
//                               <>
//                                 <Tooltip title="Accept">
//                                   <IconButton
//                                     size="small"
//                                     color="success"
//                                     onClick={() =>
//                                       updateVehicleStatus(row._id, "accept", row.fullName)
//                                     }
//                                     disabled={!!updatingStatus[row._id]}
//                                   >
//                                     {updatingStatus[row._id] ? (
//                                       <CircularProgress size={16} />
//                                     ) : (
//                                       <AcceptIcon fontSize="small" />
//                                     )}
//                                   </IconButton>
//                                 </Tooltip>

//                                 <Tooltip title="Reject">
//                                   <IconButton
//                                     size="small"
//                                     color="error"
//                                     onClick={() =>
//                                       updateVehicleStatus(row._id, "reject", row.fullName)
//                                     }
//                                     disabled={!!updatingStatus[row._id]}
//                                   >
//                                     <RejectIcon fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                               </>
//                             )}

//                             {row.status === "accept" && (
//                               <>
//                                 <Tooltip title="Send Gate Pass">
//                                   <IconButton
//                                     size="small"
//                                     color="primary"
//                                     onClick={() => sendGatePass(row._id, row.driverName)}
//                                     disabled={sendingPass}
//                                   >
//                                     <EmailIcon fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                                 <Tooltip title="Download Gate Pass">
//                                   <IconButton
//                                     size="small"
//                                     color="secondary"
//                                     onClick={() => handleDownload(row._id, row.visitorId)}
//                                     disabled={!!downloading[row._id]}
//                                   >
//                                     {downloading[row._id] ? (
//                                       <CircularProgress size={16} />
//                                     ) : (
//                                       <DownloadIcon fontSize="small" />
//                                     )}
//                                   </IconButton>
//                                 </Tooltip>
//                               </>
//                             )}

//                             <Tooltip title="Delete">
//                               <IconButton
//                                 size="small"
//                                 color="error"
//                                 onClick={() => deleteVehicleGatePass(row._id, row.driverName)}
//                               >
//                                 <DeleteIcon fontSize="small" />
//                               </IconButton>
//                             </Tooltip>
//                           </Stack>
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//             <TablePagination
//               rowsPerPageOptions={[5, 10, 25, 50]}
//               component="div"
//               count={total}
//               rowsPerPage={rowsPerPage}
//               page={page}
//               onPageChange={handleChangePage}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//             />
//           </Paper>
//         </Card>
//       </MainCard>
//     </>
//   );
// }

import * as React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Card,
  TextField,
  Button,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  CircularProgress,
} from "@mui/material";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  CheckCircle as AcceptIcon,
  Cancel as RejectIcon,
  Pending as PendingIcon,
  DirectionsCar as CarIcon,
  Email as EmailIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { gridSpacing, PASS_STATUS } from "store/constant";
import MainCard from "ui-component/cards/MainCard";
import { useDebounce } from "hooks/useDebounced";
import { useTranslation } from "react-i18next";

export default function VehicleGatePass() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sendingPass, setSendingPass] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState({});
  const [downloading, setDownloading] = useState({});
  const debouncedSearch = useDebounce(search, 1000);

  // Fetch vehicle gate pass list
  const fetchVehicleGatePasses = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        page: page + 1,
        limit: rowsPerPage,
        search,
        status: statusFilter,
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}vehicle-gate-pass-list?${queryParams}`,
        {
          method: "GET",
          headers: {
            authkey: process.env.REACT_APP_AUTH_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );

      const result = await response.json();

      if (result.code === 200) {
        setRows(result.data.vehiclePasses || []);
        setTotal(result.data.pagination?.total || 0);
      } else {
        toast.error(result.message || t("VehicleGatePass.fetchError"));
        setRows([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Error fetching vehicle gate passes:", error);
      toast.error(t("VehicleGatePass.fetchError"));
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicleGatePasses();
  }, [page, rowsPerPage, debouncedSearch, statusFilter]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleStatusFilter = (event) => {
    setStatusFilter(event.target.value);
    setPage(0);
  };

  // const updateVehicleStatus = async (id, newStatus, name) => {
  //   if (updatingStatus[id]) return;
  //   const actionText =
  //     newStatus === "accept" ? t("VehicleGatePass.accept") : t("VehicleGatePass.reject");

  //   swal({
  //     title: `${actionText} ${name}?`,
  //     text: t("VehicleGatePass.confirmStatus", { action: actionText.toLowerCase() }),
  //     icon: newStatus === "accept" ? "success" : "error",
  //     buttons: [t("VehicleGatePass.cancel"), actionText],
  //     dangerMode: newStatus === "reject",
  //   }).then(async (willProceed) => {
  //     if (!willProceed) return;

  //     try {
  //       setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_URL}update-vehicle-gate-pass-status/${id}`,
  //         {
  //           method: "PUT",
  //           headers: {
  //             authkey: process.env.REACT_APP_AUTH_KEY,
  //             Authorization: `Bearer ${localStorage.getItem("token")}`,
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({ status: newStatus, lang: localStorage.getItem("lang") }),
  //         },
  //       );

  //       const result = await response.json();
  //       if (result.code === 200) {
  //         toast.success(t("VehicleGatePass.statusUpdated", { action: actionText }));
  //         setRows((prev) =>
  //           prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item)),
  //         );
  //       } else {
  //         toast.error(
  //           result.message || t("VehicleGatePass.statusUpdateError", { action: actionText }),
  //         );
  //       }
  //     } catch (error) {
  //       console.error("Error updating gate pass status:", error);
  //       toast.error(t("VehicleGatePass.statusUpdateError", { action: actionText }));
  //     } finally {
  //       setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
  //     }
  //   });
  // };

  // const sendGatePass = async (id, name) => {
  //   setSendingPass(true);
  //   try {
  //     const response = await fetch(`${process.env.REACT_APP_API_URL}send-vehicle-gate-pass/${id}`, {
  //       method: "POST",
  //       headers: {
  //         authkey: process.env.REACT_APP_AUTH_KEY,
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ lang: localStorage.getItem("lang") }),
  //     });

  //     const result = await response.json();
  //     if (result.code === 200) {
  //       toast.success(t("VehicleGatePass.sendSuccess", { name }));
  //     } else {
  //       toast.error(result.message || t("VehicleGatePass.sendError"));
  //     }
  //   } catch (error) {
  //     console.error("Error sending gate pass:", error);
  //     toast.error(t("VehicleGatePass.sendError"));
  //   } finally {
  //     setSendingPass(false);
  //   }
  // };

  const updateVehicleStatus = async (id, newStatus, name) => {
    if (updatingStatus[id]) return;

    // STEP 1: Language selection
    const langChoice = await swal({
      title: t("VehicleGatePass.chooseLanguageTitle"),
      text: t("VehicleGatePass.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    const actionText =
      newStatus === PASS_STATUS.ACCEPTED
        ? t("VehicleGatePass.accept")
        : t("VehicleGatePass.reject");

    // STEP 2: Confirm action
    const willProceed = await swal({
      title: `${actionText} ${name}?`,
      text: t("VehicleGatePass.confirmStatus", {
        action: actionText.toLowerCase(),
      }),
      icon: newStatus === PASS_STATUS.ACCEPTED ? "success" : "error",
      buttons: [t("VehicleGatePass.cancel"), actionText],
      dangerMode: newStatus === PASS_STATUS.REJECTED,
    });

    if (!willProceed) return;

    try {
      setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}update-vehicle-gate-pass-status/${id}`,
        {
          method: "PUT",
          headers: {
            authkey: process.env.REACT_APP_AUTH_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            status: newStatus,
            lang: langChoice, // ✅ explicit language
          }),
        },
      );

      const result = await response.json();

      if (result.code === 200) {
        toast.success(t("VehicleGatePass.statusUpdated", { action: actionText }));

        setRows((prev) =>
          prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item)),
        );
      } else {
        toast.error(
          result.message ||
            t("VehicleGatePass.statusUpdateError", {
              action: actionText,
            }),
        );
      }
    } catch (error) {
      console.error("Error updating vehicle gate pass status:", error);
      toast.error(t("VehicleGatePass.statusUpdateError", { action: actionText }));
    } finally {
      setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
    }
  };

  const sendGatePass = async (id, name) => {
    const langChoice = await swal({
      title: t("VehicleGatePass.chooseLanguageTitle"),
      text: t("VehicleGatePass.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    setSendingPass(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}send-vehicle-gate-pass/${id}`, {
        method: "POST",
        headers: {
          authkey: process.env.REACT_APP_AUTH_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ lang: langChoice }),
      });

      const result = await response.json();
      if (result.code === 200) {
        toast.success(t("VehicleGatePass.sendSuccess", { name }));
      } else {
        toast.error(result.message || t("VehicleGatePass.sendError"));
      }
    } catch (error) {
      console.error("Error sending gate pass:", error);
      toast.error(t("VehicleGatePass.sendError"));
    } finally {
      setSendingPass(false);
    }
  };

  const handleDownload = async (id, visitorId) => {
    const choice = await swal({
      title: t("VehicleGatePass.downloadOptions.title"),
      text: t("VehicleGatePass.downloadOptions.text"),
      icon: "info",
      buttons: {
        gatepass: {
          text: t("VehicleGatePass.downloadOptions.gatePass"),
          value: "gatepass",
        },
        details: {
          text: t("VehicleGatePass.downloadOptions.details"),
          value: "details",
        },
      },
    });

    if (!choice) return;
    if (downloading[id]) return;

    setDownloading((prev) => ({ ...prev, [id]: true }));

    try {
      let endpoint = "";
      let fileName = "";

      if (choice === "gatepass") {
        endpoint = `${process.env.REACT_APP_API_URL}download-gatepass-vehicle/${id}`;
        fileName = `GatePass_${visitorId}.pdf`;
      } else if (choice === "details") {
        endpoint = `${process.env.REACT_APP_API_URL}download-gatepass-vehicle-details/${id}`;
        fileName = `VehicleGatePassDetails_${visitorId}.pdf`;
      } else {
        return;
      }

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          authkey: process.env.REACT_APP_AUTH_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ lang: localStorage.getItem("lang") }),
      });

      if (!response.ok) {
        toast.error(t("VehicleGatePass.downloadError"));
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        toast.success(t("VehicleGatePass.downloadSuccess"));
      }, 100);
    } catch (error) {
      console.error("Download error:", error);
      toast.error(t("VehicleGatePass.somethingWentWrong"));
    } finally {
      setDownloading((prev) => ({ ...prev, [id]: false }));
    }
  };

  const deleteVehicleGatePass = (id, name) => {
    swal({
      title: t("VehicleGatePass.deleteTitle", { name }),
      text: t("VehicleGatePass.deleteText"),
      icon: "warning",
      buttons: [t("VehicleGatePass.cancel"), t("VehicleGatePass.delete")],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (!willDelete) return;

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}delete-vehicle-gate-pass/${id}`,
          {
            method: "DELETE",
            headers: {
              authkey: process.env.REACT_APP_AUTH_KEY,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );

        const result = await response.json();
        if (result.code === 200) {
          toast.success(t("VehicleGatePass.deleteSuccess"));
          setRows((prev) => prev.filter((item) => item._id !== id));
          setTotal((prev) => prev - 1);
        } else {
          toast.error(result.message || t("VehicleGatePass.deleteError"));
        }
      } catch (error) {
        console.error("Error deleting vehicle gate pass:", error);
        toast.error(t("VehicleGatePass.deleteError"));
      }
    });
  };

  const getStatusChip = (status) => {
    const statusConfig = {
      pending: { color: "warning", icon: <PendingIcon />, label: t("VehicleGatePass.pending") },
      accept: { color: "success", icon: <AcceptIcon />, label: t("VehicleGatePass.accepted") },
      reject: { color: "error", icon: <RejectIcon />, label: t("VehicleGatePass.rejected") },
    };
    const config = statusConfig[status] || statusConfig.pending;
    return (
      <Chip
        icon={config.icon}
        label={config.label}
        color={config.color}
        size="small"
        variant="outlined"
      />
    );
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label={t("VehicleGatePass.searchLabel")}
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={t("VehicleGatePass.searchPlaceholder")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel>{t("VehicleGatePass.statusFilter")}</InputLabel>
            <Select
              value={statusFilter}
              onChange={handleStatusFilter}
              label={t("VehicleGatePass.statusFilter")}
            >
              <MenuItem value="all">{t("VehicleGatePass.allStatus")}</MenuItem>
              <MenuItem value="pending">{t("VehicleGatePass.pending")}</MenuItem>
              <MenuItem value="accept">{t("VehicleGatePass.accepted")}</MenuItem>
              <MenuItem value="reject">{t("VehicleGatePass.rejected")}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <MainCard
        title={
          <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
            <Grid item>
              <Typography variant="h3">{t("VehicleGatePass.title", { total })}</Typography>
            </Grid>
          </Grid>
        }
        content={false}
      >
        <Card>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader aria-label="vehicle gate pass table">
                <TableHead>
                  <TableRow>
                    <TableCell>{t("VehicleGatePass.sNo")}</TableCell>
                    <TableCell>{t("VehicleGatePass.idIqama")}</TableCell>
                    <TableCell>{t("VehicleGatePass.name")}</TableCell>
                    <TableCell>{t("VehicleGatePass.vehicleNo")}</TableCell>
                    <TableCell align="center">{t("VehicleGatePass.company")}</TableCell>
                    <TableCell>{t("VehicleGatePass.contact")}</TableCell>
                    {/* <TableCell>{t("VehicleGatePass.entryTime")}</TableCell> */}
                    <TableCell>{t("sidebar.Department")}</TableCell>
                    <TableCell>{t("VehicleGatePass.hodStatus")}</TableCell>
                    <TableCell>{t("VehicleGatePass.status")}</TableCell>
                    <TableCell align="center">{t("VehicleGatePass.actions")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <Typography>{t("VehicleGatePass.loading")}</Typography>
                      </TableCell>
                    </TableRow>
                  ) : rows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <Typography>{t("VehicleGatePass.noData")}</Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    rows.map((row, index) => (
                      <TableRow hover key={row._id}>
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold" color="primary">
                            {row.idIqama}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold">
                            {row.fullName}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip
                            icon={<CarIcon />}
                            label={row.vehicles[0]?.plateNo || "N/A"}
                            size="small"
                            variant="outlined"
                            color="primary"
                          />
                        </TableCell>
                        <TableCell align="center">{row.companyName || "N/A"}</TableCell>
                        <TableCell>
                          <Typography variant="body2">{row.mobile}</Typography>
                          <Typography variant="caption" color="textSecondary">
                            {row.email}
                          </Typography>
                        </TableCell>
                        {/* <TableCell>
                          <Typography variant="caption" display="block">
                            {t("VehicleGatePass.from")}: {formatDate(row.visitStart)}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            {t("VehicleGatePass.to")}: {formatDate(row.visitEnd)}
                          </Typography>
                        </TableCell> */}
                        <TableCell>{row.department.name}</TableCell>
                        <TableCell>{getStatusChip(row.staff_status)}</TableCell>
                        <TableCell>{getStatusChip(row.status)}</TableCell>
                        <TableCell align="center">
                          <Stack direction="row" spacing={0.5} justifyContent="center">
                            <Tooltip title={t("VehicleGatePass.view")}>
                              <IconButton
                                size="small"
                                color="info"
                                onClick={() => navigate(`/vehicle-gatepass/${row._id}`)}
                              >
                                <ViewIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            {row.staff_status !== PASS_STATUS.REJECTED &&
                              row.status === PASS_STATUS.PENDING && (
                                <>
                                  <Tooltip title={t("VehicleGatePass.accept")}>
                                    <IconButton
                                      size="small"
                                      color="success"
                                      onClick={() =>
                                        updateVehicleStatus(
                                          row._id,
                                          PASS_STATUS.ACCEPTED,
                                          row.fullName,
                                        )
                                      }
                                      disabled={!!updatingStatus[row._id]}
                                    >
                                      {updatingStatus[row._id] ? (
                                        <CircularProgress size={16} />
                                      ) : (
                                        <AcceptIcon fontSize="small" />
                                      )}
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip title={t("VehicleGatePass.reject")}>
                                    <IconButton
                                      size="small"
                                      color="error"
                                      onClick={() =>
                                        updateVehicleStatus(
                                          row._id,
                                          PASS_STATUS.REJECTED,
                                          row.fullName,
                                        )
                                      }
                                      disabled={!!updatingStatus[row._id]}
                                    >
                                      <RejectIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}
                            {row.status === PASS_STATUS.ACCEPTED && (
                              <>
                                <Tooltip title={t("VehicleGatePass.sendGatePass")}>
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() => sendGatePass(row._id, row.driverName)}
                                    disabled={sendingPass}
                                  >
                                    <EmailIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title={t("VehicleGatePass.downloadGatePass")}>
                                  <IconButton
                                    size="small"
                                    color="secondary"
                                    onClick={() => handleDownload(row._id, row.visitorId)}
                                    disabled={!!downloading[row._id]}
                                  >
                                    {downloading[row._id] ? (
                                      <CircularProgress size={16} />
                                    ) : (
                                      <DownloadIcon fontSize="small" />
                                    )}
                                  </IconButton>
                                </Tooltip>
                              </>
                            )}
                            <Tooltip title={t("VehicleGatePass.delete")}>
                              <IconButton
                                size="small"
                                color="error"
                                onClick={() => deleteVehicleGatePass(row._id, row.driverName)}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Card>
      </MainCard>
    </>
  );
}
